import type { ReactNode } from "react";
import type { QuestionStepProps } from "./types";

interface QuestionStepShellProps extends QuestionStepProps {
  children: ReactNode;
  footer?: ReactNode;
}

export function QuestionStepShell({
  question,
  questionIndex,
  totalQuestions,
  onBack,
  canGoBack,
  children,
  footer,
}: QuestionStepShellProps) {
  const progress = ((questionIndex + 1) / totalQuestions) * 100;
  const isScenario = question.kind === "scenario";

  return (
    <div className="bloom-question">
      <div className="bloom-progress">
        <p className="bloom-progress__label">
          Vraag {questionIndex + 1} van {totalQuestions}
        </p>
        <div
          className="bloom-progress__bar"
          role="progressbar"
          aria-valuenow={progress}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          <div className="bloom-progress__fill" style={{ width: `${progress}%` }} />
        </div>
      </div>

      <div className="bloom-question__card" data-question-id={question.id}>
        {isScenario ? (
          <>
            <div className="bloom-scenario-block">
              <p className="bloom-scenario__label">Situatie</p>
              <p className="bloom-scenario__situation">{question.situation}</p>
            </div>
            <p className="bloom-question__text bloom-scenario__prompt">{question.prompt}</p>
          </>
        ) : (
          <p className="bloom-question__text">{question.text}</p>
        )}
        {children}
      </div>

      <div className="bloom-question__nav">
        {canGoBack ? (
          <button type="button" className="bloom-btn bloom-btn--ghost" onClick={onBack}>
            Terug
          </button>
        ) : (
          <span />
        )}
        {footer}
      </div>
    </div>
  );
}
